<template>
  <div class="background">

    <v-row>
      <v-col md="8" class="pa-0">
        <!-- PAGE -->
        <div class="noprint-frame">
          <v-row class="justify-end">
            <img class="mr-3" src="https://puravida-organic.com/wp-content/uploads/2019/10/playfair-display-outline.svg" width="300px" />
          </v-row>
          <div class="display-1 mt-4 mb-2">
            {{ invoice.type === 0 ? Translation.get('Invoice', lang) : Translation.get('Refund', lang) }}
          </div>
          <v-layout>
            
            <v-flex xs6>

              <div>
                <div class="font-weight-bold">
                  Pura Vida Organic d.o.o
                </div>
                Ul. dr. Luje Naletilića 57<br />
                Zagreb, 10000<br />
                Hrvatska / Croatia<br />
                PDV ID / VAT ID HR48747504211<br />
                EORI ID HR48747504211<br />
                +385 98 916 0450<br />
                www.puravida-organic.com

                <div class="mt-4 mb-4">
                  <div class="font-weight-medium">
                    Puravida Bank account
                  </div>
                  Bank: HPB <br />
                  Address: Jurišićeva 4, 10000 Zagreb, Croatia <br />
                  IBAN: HR4323900011101112639 <br />
                  SWIFT: HPBZHR2X <br />
                </div>

              </div>
            </v-flex>
            <v-flex xs6>

              <div>
                <span v-if="lang === 'hrk'">Datum: {{ date }}</span>
                <span v-else-if="lang === 'eng'">Date: {{ date }}</span>
              </div>

              <div>
                {{ Translation.get('Invoice ID', lang) }}: {{ invoice.id_visual }}
              </div>

              <div>
                <span v-if="lang === 'hrk'">Šifra kupca: {{ customer.id }}</span>
                <span v-else-if="lang === 'eng'">Customer ID: {{ customer.id }}</span>
              </div>

              <div class="mt-2">
                <div class="font-weight-bold">
                  {{ Translation.get('Bill to', lang) }}:
                </div>
                <div style="white-space: pre;">{{ invoice.invoice_addr }}</div>
              </div>

              <div class="mt-4">
                <div class="font-weight-bold">
                  {{ Translation.get('Ship to', lang) }}:
                </div>
                <div 
                v-if="invoice.delivery_addr"
                style="white-space: pre;">{{ invoice.delivery_addr }}</div>
                <div v-else>
                  {{ Translation.get('same as billing address', lang) }}
                </div>
              </div>

            </v-flex>
          </v-layout>
          
          <table :class="['final-table th-no-padding lines-b full-width']">
            <tr>
              <td>
                <span class="font-weight-bold">
                  <span v-if="lang === 'hrk'">Odgovorna osoba:</span>
                  <span v-else-if="lang === 'eng'">Sales rep:</span>
                </span> Jennifer Deegan
              </td>
              <td>
              </td>
              <td>
              </td>
            </tr>
          </table>

          <div class="c-hr"></div>

          <table :class="['final-table th-no-padding compact lines-b lines-r full-width']">
            <colgroup ref="colgroup1">
                <col width="25%">
                <col width="15%">
                <col width="15%">
                <col width="15%">
                <col width="15%">
                <col width="10%">
                <col width="15%">
            </colgroup>

            <tr class="caption">
              <c-table-header
              :title="Translation.get('Item', lang)"
              code="item"
              :filters="filters"
              @onClick="clickSortHeader">
              </c-table-header>
              <c-table-header
              :title="Translation.get('Quantity', lang)"
              code="quantity"
              :filters="filters"
              @onClick="clickSortHeader">
              </c-table-header>
              <c-table-header
              :title="Translation.get('Weight', lang)"
              code="weight"
              :filters="filters"
              @onClick="clickSortHeader">
              </c-table-header>
              <c-table-header
              :title="Translation.get('Unit price', lang)"
              code="unit_price"
              :filters="filters"
              @onClick="clickSortHeader">
              </c-table-header>
              <c-table-header
              :title="Translation.get('Total', lang)"
              code="total"
              :filters="filters"
              @onClick="clickSortHeader">
              </c-table-header>
              <c-table-header
              :title="Translation.get('Discount', lang) + '%'"
              code="discount"
              :filters="filters"
              @onClick="clickSortHeader">
              </c-table-header>
              <c-table-header
              :title="Translation.get('Total', lang)"
              code="final_total"
              :filters="filters"
              @onClick="clickSortHeader">
              </c-table-header>
            </tr>

            <quote-row
            v-for="item in items" 
            :key="item.tempID"
            vmode="table"
            :currency="printSettings.currency"
            :rateMultiplier="rateMultiplier"
            :item="item"
            :selected="selected"
            :sortIndex="sortIndex"
            :searchText="searchText"
            ></quote-row>

          </table>

          <v-row>
            <v-col md="4">
              <div>
                {{ Translation.get('Total weight', lang) }}:
                <c-ms-ii
                sid="si-mass-g"
                :realValue="totalWeight"
                labelMode
                class="font-weight-medium"
                ></c-ms-ii>               
              </div>
            </v-col>
            <v-col md="8">
              <v-card class="elevation-0 pa-2">
                <table class="final-table compact full-width text-end">
                  <colgroup>
                    <col width="10px">
                    <col width="10px">
                    <col v-if="printSettings.currency === hrkInt" width="10px">
                  </colgroup>

                  <tr>
                    <td>
                      {{ Translation.get('Subtotal', lang) }}
                    </td>
                    <td>
                      <c-price :quantity="netTotalCostSumFixed" labelMode :currency="printSettings.currency">
                      </c-price>
                    </td>
                    <td v-if="printSettings.currency === hrkInt">
                      <c-price :quantity="Number(netTotalCostSumFixed) / euroHrkRate" labelMode :currency="euroInt">
                      </c-price>
                    </td>
                  </tr>

                  <tr>
                    <td>
                      <span v-if="lang === 'hrk'">Rabat</span>
                      <span v-else-if="lang === 'eng'">Discount</span>
                    </td>
                    <td>
                      <c-price :quantity="netDiscount" labelMode :currency="printSettings.currency">
                      </c-price>
                    </td>
                    <td v-if="printSettings.currency === hrkInt">
                      <c-price :quantity="Number(netDiscount) / euroHrkRate" labelMode :currency="euroInt">
                      </c-price>
                    </td>
                  </tr>

                  <tr>
                    <td>
                      <span v-if="lang === 'hrk'">PDV (%)</span>
                      <span v-else-if="lang === 'eng'">VAT (%)</span>
                    </td>
                    <td>
                      {{ invoice.tax }}%
                    </td>
                    <td v-if="printSettings.currency === hrkInt">
                      {{ invoice.tax }}%
                    </td>
                  </tr>

                  <tr>
                    <td>
                      <span v-if="lang === 'hrk'">PDV</span>
                      <span v-else-if="lang === 'eng'">VAT</span>
                    </td>
                    <td>
                      <c-price :quantity="totalVAT" labelMode :currency="printSettings.currency">
                      </c-price>
                    </td>
                    <td v-if="printSettings.currency === hrkInt">
                      <c-price :quantity="Number(totalVAT) / euroHrkRate" labelMode :currency="euroInt">
                      </c-price>
                    </td>
                  </tr>

                  <tr>
                    <td>
                      {{ Translation.get('Paid', lang) }}
                    </td>
                    <td>
                      <c-price 
                      :quantity="amountPaid" 
                      :currency="printSettings.currency"
                      labelMode>
                      </c-price>
                    </td>
                    <td v-if="printSettings.currency === hrkInt">
                      <c-price :quantity="Number(amountPaid) / euroHrkRate" labelMode :currency="euroInt">
                      </c-price>
                    </td>
                  </tr>


                  <tr class="font-weight-bold">
                    <td>
                      {{ invoice.type === 0 ? Translation.get('To Pay', lang) : Translation.get('Refund', lang) }}
                    </td>
                    <td>
                      <c-price :quantity="amountDue" labelMode :currency="printSettings.currency">
                      </c-price>
                    </td>
                    <td v-if="printSettings.currency === hrkInt">
                      <c-price :quantity="Number(amountDue) / euroHrkRate" labelMode :currency="euroInt">
                      </c-price>
                    </td>
                  </tr>

                </table>
              </v-card>
            </v-col>
          </v-row>

          <div v-if="printSettings.currency === hrkInt" class="caption mb-3">
            ** A fixed rate of 1 EUR = {{ euroHrkRate }} HRK was used. Please note we do not accept Euros from Croatian companies until January 2023.
          </div>

          <div v-if="!invoice.tax" class="mt-4 mb-4 text-xs-center">
            VAT is not charged according to the Article 41, Paragraph 1 of the Croatian Value Added Tax Law. Reverse charge.<br />
            PDV nije obračunan temeljem članka 41. stavka 1. Zakona o porezu na dodanu vrijednost. Prijenos porezne obveze.<br />
          </div>

          <v-row>
            <v-col md="6">
              <v-card outlined>
                <div class="pa-2 font-weight-medium">
                  <span v-if="lang === 'hrk'">Napomena /</span> Comments or Special Instructions
                </div>
                <div class="pa-3">
                  1. Total payment due immediately.<br />
                  2. Please include the invoice number on your bank transfer.<br />
                  3. In the event that Customer does not reject the received Product(s) within the 10-day period from then the Product(s) shall be deemed to be accepted by Customer and will not be accepted back by PURA VIDA ORGANIC.<br /><br />
                  
                  <div v-if="lang === 'hrk'">
                    Sud upisa u registar Trgovački sud u Zagrebu ● MBS 081137146 ● MB 04828496 ●     OIB 48747504211 ● VAT ID HR48747504211 ● EORI ID HR48747504211 ● Temeljni kapital: 20.000,00 kn uplaćen u cijelosti ● Direktor: Jennifer Deegan             
                    Poslovni račun HPB banka d.d.  ● IBAN HR4323900011101112639 ● SWIFT HPBZHR2X
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <div class="font-weight-bold subheading text-center">
            Thank You For Choosing Organic 🌿
          </div>
          <div class="font-weight-bold red--text subheading text-center mt-8">
            <img class="mr-3" src="https://puravida-organic.com/wp-content/uploads/2020/04/all-badges-black.png" width="100%" />
          </div>

        </div>
        <!-- PAGE -->
      </v-col>

      <v-col md="4" class="noprint">
        <!-- SETTINGS -->
        <v-card outlined class="ml-4 mr-4" style="position: sticky; top: 20px;">
          <v-row class="pa-2">
            Print Settings
          </v-row>
          <div class="pa-4">
            <v-row class="align-center">
              <v-col md="3">
                <div class="label">Language:</div>
              </v-col>
              <v-col md="9">
                <select-language class="crx-box-input" selectedCode="eng" @change="onChangeLanguage"></select-language>
              </v-col>
            </v-row>
            <v-row class="align-center">
              <v-col md="3">
                <div class="label">Currency:</div>
              </v-col>
              <v-col md="9">
                <c-select-currency :selectedID.sync="printSettings.currency" class="crx-box-input" @change="onChangeCurrency"></c-select-currency>
              </v-col>
            </v-row>

            <!-- CONVERSION BLOCK -->
            <div v-show="conversionNecessary">
              <v-row class="align-center">
                <v-col md="3">
                  <div class="label">Conversion rate:</div>
                </v-col>
                <v-col md="9">
                  <v-row class="align-center caption">
                    {{ baseCurrencyLabel.symbol }}
                    <v-icon small>mdi-swap-horizontal</v-icon>
                    {{ printCurrencyLabel.symbol }}
                  </v-row>
                  <c-input :value.sync="printSettings.rate" class="crx-box-input"></c-input>
                  <!-- conversion warning -->
                  <div class="caption red--text">
                    * Make sure this conversion rate is correct
                  </div>
                </v-col>

                <automatic-currency-rate :currency="invoice.currency" @updateRate="updateRate" @updateRateAutomatic="updateRateAutomatic" :baseCurrency="printSettings.currency" class="mt-2"></automatic-currency-rate>
              </v-row>
            </div>

            <v-row class="justify-end mt-3">
              <v-btn @click="onPrint" color="color1" class="white--text">
                PRINT
              </v-btn>
            </v-row>
      
          </div>
        </v-card>
        <!-- SETTINGS -->
      </v-col>
    </v-row>

  </div>
</template>

<script>
import QuoteRow from '@/views/sales-quotes/print/quote-row'
import ListController from '@/mixins/ListController'
import Translation from '@/js/translations'
import SelectLanguage from '@/components/select/SelectLanguage'
import AutomaticCurrencyRate from '@/components/select/AutomaticCurrencyRate'

export default {
  props: ['id'],
  components: {
    QuoteRow,
    SelectLanguage,
    AutomaticCurrencyRate
  },
  mixins: [ListController],
  data () {
    return {
      items: [],
      invoice: {},
      customer: {},
      lang: 'eng',
      Translation,
      printSettings: {
        currency: null,
        rate: null
      },

      euroHrkRate: 7.53450
    }
  },
  computed: {
    euroInt () {
      return 47
    },
    hrkInt () {
      return 61
    },
    baseCurrencyLabel () {
      return this.$store.state.db.currencies.items[this.invoice.currency] || {}
    },
    printCurrencyLabel () {
      return this.$store.state.db.currencies.items[this.printSettings.currency] || {}
    },
    conversionNecessary () {
      if (this.invoice.currency !== this.printSettings.currency) {
        return true
      }
      return false
    },
    rateMultiplier () {
      if (!this.conversionNecessary) {
        return 1
      }
      return this.printSettings.rate || 1
    },
    totalWeight () {
      return this.items.reduce((a, i) => a + i.weight, 0)
    },
    netTotalCostSum () {
      return this.items.reduce((a, i) => {
        return a + i.total_cost
      }, 0) * this.rateMultiplier
    },
    netTotalCostSumFixed() {     
      return Number(this.netTotalCostSum).toFixed(2)
    },
    netDiscount () {
      return this.items.reduce((a, i) => {
        var discount = (i.discount || 0) / 100
        return a + (i.total_cost * discount)
      }, 0) * this.rateMultiplier
    },
    subtotalMinusDiscount () {
      return this.netTotalCostSum - this.netDiscount
    },
    totalVAT () {
      var percent = Number(this.invoice.tax) / 100
      return this.subtotalMinusDiscount * percent
    },
    amountPaid () {
      return this.invoice.paid * this.rateMultiplier
    },
    amountDue () {
      return this.subtotalMinusDiscount + this.totalVAT - this.amountPaid
    },
    date () {
      return this.$moment(this.invoice.date).format('DD/MM/YYYY')
    },
  },
  methods: {
    updateRate (rate) {
      this.printSettings.rate = rate.rate
    },
    updateRateAutomatic (rate) {
      if (!this.printSettings.rate) {
        this.printSettings.rate = rate.rate
      }
      if (this.printSettings.currency !== this.invoice.currency) {
        this.printSettings.rate = rate.rate
      }

      if (this.printSettings.currency === this.invoice.currency) {
        this.printSettings.rate = 1
      }
    },
    getInvoice () {
      return new Promise((resolve, reject) => {
        var invoice, customer, invoiceItems

        this.$axios.get('/sales-invoices/' + this.id)
          .then(response => {
            invoice = response.data.invoice
            invoiceItems = response.data.rows
            console.log(invoiceItems)
            invoiceItems.map(item => {
              item.json_data = JSON.parse(item.json_data)
              item.custom_columns = JSON.parse(item.custom_columns)
            })
            return this.$axios.get('/customers/' + invoice.customer)
          })
          .then(_customer => {
            customer = _customer.data
            var res = {
              customer: customer,
              invoice: invoice,
              invoiceItems: invoiceItems
            }
            resolve(res)
          })
          .catch(error => {
            console.log(error)
            this.$root.$errorSnackbar(error)
            reject(error)
          })
      })
    },
    reload () {
      this.getInvoice()
        .then(response => {
          console.log(response.invoice)
          this.invoice = response.invoice
          this.items = response.invoiceItems
          this.customer = response.customer
          this.printSettings.currency = response.invoice.currency
        })
        .catch(error => this.$root.$errorSnackbar(error))
    },
    onPrint () {
      window.print()
    },
    onChangeLanguage (nv) {
      this.lang = nv.code
    },
    onChangeCurrency (nv) {
      /* console.log(nv)
      var swapFound = Object.values(this.$store.state.db.currencyRates.items).find(item => item.currency_1 === this.invoice.currency && item.currency_2 === this.printSettings.currency)
      if (swapFound) {
        this.printSettings.rate = swapFound.rate
      } else {
        this.printSettings.rate = 1
      }
      */
    }
  },
  created () {
    this.reload()
  }
}
</script>

<style scoped lang="scss">
::v-deep.crx-box-input {
  background: #f7fafc!important; /* fallback for print mode */
}

.noprint-frame {
  margin: 20px;
  padding: 50px;
  background: white;
}

/* PRINTING */
@media print { 
  .noprint-frame { 
     margin: 0px!important;
     padding: 0px!important;
  } 
} 
</style>
